import React from 'react';
import NewsCard from './NewsCard';
import SubsctibeCard from './SubscribeCard';
import './styles.scss';

const NewsCards = ({ posts = [], subscribeTitle, subscribeDescription, subscribePolicy }) => (
    <div className="news-cards">
        {posts.map(item => (
            <NewsCard key={item.title} data={item} />
        ))}
        <SubsctibeCard title={subscribeTitle} description={subscribeDescription} policy={subscribePolicy} />
    </div>
);

export default NewsCards;
